import { useState } from "react";
import {ReactComponent as PhoneIcon} from './icons/un-telephone.svg'

const NextButton = (props) => {

  return (
    <button
      className={`ec-navigation ec-navigation__next`}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

export default NextButton;
